import { Select } from '../../input';
import { Error } from '../../error';

const visiterChoices = [
  ['playwright', 'Playwright'],
  ['fetch', 'fetch()'],
];

export const VisiterInput = ({ params, onChange, errors }) => (
  <>
    <Select
      label="Rendering"
      style={{ width: 120 }}
      value={params.visiter}
      onChange={(val) => onChange('visiter', val)}
      choices={visiterChoices}
    />
    <Error message={errors?.visiter} />
  </>
);
